import React, { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { toast } from "sonner";

export default function VoteButtons({ project, onChange, requestLogin, size = "md" }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState({
    score: project.score,
    upvotes: project.upvotes,
    downvotes: project.downvotes,
    user_vote: project.user_vote,
  });

  React.useEffect(() => {
    setState({
      score: project.score,
      upvotes: project.upvotes,
      downvotes: project.downvotes,
      user_vote: project.user_vote,
    });
  }, [project.score, project.upvotes, project.downvotes, project.user_vote]);

  const sendVote = async (target) => {
    if (!user) { requestLogin?.(); return; }
    if (busy) return;
    setBusy(true);
    const newValue = state.user_vote === target ? 0 : target;
    try {
      const { data } = await api.post(`/projects/${project.project_id}/vote`, { value: newValue });
      setState({ score: data.score, upvotes: data.upvotes, downvotes: data.downvotes, user_vote: data.user_vote });
      onChange?.(data);
    } catch (e) {
      toast.error("Votul nu a putut fi salvat");
    } finally {
      setBusy(false);
    }
  };

  const upActive = state.user_vote === 1;
  const downActive = state.user_vote === -1;
  const iconSize = size === "lg" ? 22 : 18;

  return (
    <div
      className={`inline-flex items-center gap-1 select-none ${size === "lg" ? "text-lg" : "text-sm"}`}
      data-testid={`vote-controls-${project.project_id}`}
    >
      <button
        type="button"
        disabled={busy}
        onClick={() => sendVote(1)}
        aria-label="Susțin"
        data-testid={`upvote-btn-${project.project_id}`}
        className={`grid place-items-center rounded-sm border transition-colors ${
          size === "lg" ? "w-11 h-11" : "w-9 h-9"
        } ${upActive ? "bg-[#00D670] border-[#00D670] text-[#0B1C14]" : "bg-white border-border hover:border-foreground/40"}`}
      >
        <ChevronUp size={iconSize} strokeWidth={2.25} />
      </button>
      <span className={`font-display font-bold tabular-nums px-2 ${size === "lg" ? "min-w-12 text-center" : "min-w-8 text-center"}`}>
        {state.score}
      </span>
      <button
        type="button"
        disabled={busy}
        onClick={() => sendVote(-1)}
        aria-label="Nu susțin"
        data-testid={`downvote-btn-${project.project_id}`}
        className={`grid place-items-center rounded-sm border transition-colors ${
          size === "lg" ? "w-11 h-11" : "w-9 h-9"
        } ${downActive ? "bg-foreground border-foreground text-background" : "bg-white border-border hover:border-foreground/40"}`}
      >
        <ChevronDown size={iconSize} strokeWidth={2.25} />
      </button>
    </div>
  );
}
